export default {
  data () {
    return {
      dialogData: {},
      dialogOption: {
        show: false,
        view: null,
        title: '',
        width: '1200px'
      }
    }
  },
  methods: {
    /*
    * 显示弹窗
    */
    showDialog (view, title, width = '800px') {
      this.dialogOption.show = true
      this.dialogOption.view = view
      this.dialogOption.title = title
      this.dialogOption.width = width
    },
    /*
    * 关闭弹窗
    */
    closeDialog () {
      this.dialogOption = {
        show: false,
        view: null,
        title: '',
        width: '0px'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/layout/pages/home/dialog.js